import styled from 'styled-components';

import { WarningTag } from '../../../../../components/Tags';
import CollapsibleSelect from '../../../../../components/v2/CollapsibleSelect';

const TagList = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 5px;
`;

const ExerciseName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

// Truncates long names so anything after them in the cell (the video issue icon) stays visible.
const ExerciseNameText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Thumbnail = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 3px;
`;

const StyledCollapsibleSelect = styled(CollapsibleSelect)`
  width:  ${(props) => (props.$isWorkoutDesignerView ? '200px' : '250px')};

  @media (max-width: 1240px) {
    width: 250px;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export {
  TagList,
  WarningTag as ExerciseTag,
  ExerciseName,
  ExerciseNameText,
  Thumbnail,
  StyledCollapsibleSelect,
  HeaderActions,
};
